module.exports = __webpack_public_path__ + "assets/img/17@3x.4aa1ea1f.png";